import {h} from 'preact';
import {localizeURL} from '@util/URLUtils';

const cls = 'flex justify-between items-center p-4 border-b border-solid border-grey-lighter';
const ListItemLink = ( {as, className = '', children, href, ...props} ) => {
    const Element = as || 'div';
    const attrs = {};

    if ( href && as === 'a' ) {
        attrs.href = localizeURL( href );
    }

    return (
        <Element
            className={[cls, className].join( ' ' )} {...props} {...attrs}>
            {children}
        </Element>
    );
};

export default ListItemLink;
